import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

// Backend constants (TASKS/IT-120046/p1/readp1.md): IpfCostItemRS.Category is one of these.
export const IPF_CATEGORY = {
  PRODUCTION: 'Production',
  SUPPLIER: 'Supplier',
  TRANSPORT: 'Transport',
  PROCESSING: 'Processing'
};

// Display title per section — labels follow the client's sample sheet (image.png), not the raw backend constant.
export const COST_SECTIONS = [
  { category: IPF_CATEGORY.PRODUCTION, title: 'Production' },
  { category: IPF_CATEGORY.SUPPLIER, title: 'Supplier' },
  { category: IPF_CATEGORY.TRANSPORT, title: 'Despatch - Transport' },
  { category: IPF_CATEGORY.PROCESSING, title: 'Processing / System' }
];

// Working week for the IPF summary table: Monday -> Saturday of the week containing `date` (no Sunday row, matches sample sheet).
export function getWeekRange(date) {
  const start = dayjs(date, 'YYYY-MM-DD').startOf('isoWeek');
  const days = Array.from({ length: 6 }, (_, i) => start.add(i, 'day').format('YYYY-MM-DD'));
  return { startDate: days[0], endDate: days[days.length - 1], days };
}

// White/Foiled split temporarily dropped per user request (2026-08-18) — total count/cost per day only.
export function buildCategoryRows(records, category, days) {
  const byCategory = records.filter(r => r.category === category);

  const rows = days.map(day => {
    const dayRecords = byCategory.filter(r => r.ipfDate && dayjs(r.ipfDate).format('YYYY-MM-DD') === day);
    return {
      date: day,
      count: dayRecords.length,
      totalCost: dayRecords.reduce((sum, r) => sum + (r.ipfMaterialCost || 0), 0)
    };
  });

  const totals = {
    date: 'TOTAL',
    count: rows.reduce((sum, r) => sum + r.count, 0),
    totalCost: rows.reduce((sum, r) => sum + r.totalCost, 0)
  };

  return { rows, totals };
}

export function buildFaultCodeCounts(records) {
  const counts = {};
  records.forEach(r => {
    const code = r.pCode || 'Unknown';
    counts[code] = (counts[code] || 0) + 1;
  });

  return Object.entries(counts)
    .map(([code, count]) => ({ code, count }))
    .sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));
}

export function formatCost(value) {
  return `£${(value || 0).toFixed(2)}`;
}
